import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { map } from 'rxjs/operators';
import * as _ from 'lodash';
import { Observable } from 'rxjs';
import { SettingsService } from '../../core/services/settings.service';
import { AutoGroup } from 'src/app/carbrewer/models/auto-group.interface';
import { Dealer } from '../models/dealer.interface';

@Injectable({
  providedIn: 'root',
})
export class ElevationService {
  private baseUrl = environment.nestElevationApiUrl;
  constructor(
    private http: HttpClient, // private errorHandlerService: ErrorHandlerService
    private appSettings: SettingsService,
  ) {}

  get(url, params = {}, options?): Observable<any> {
    const queryString =
      url.indexOf('?') == -1 && !_.isEmpty(params)
        ? '?' + new URLSearchParams(params).toString()
        : '';
    return this.http.get(
      `${environment.nestElevationApiUrl}${url}${queryString}`,
      options,
    );
  }
  post(url, params, options?): Observable<any> {
    return this.http.post(
      `${environment.nestElevationApiUrl}${url}`,
      params,
      options,
    );
  }
  put(url, params): Observable<any> {
    return this.http.put(`${environment.nestElevationApiUrl}${url}`, params);
  }
  patch(url, params): Observable<any> {
    return this.http.patch(`${environment.nestElevationApiUrl}${url}`, params);
  }
  delete(url, params = {}): Observable<any> {
    return this.http.delete(`${environment.nestElevationApiUrl}${url}`, params);
  }

  getData(
    url,
    data?,
    options: {
      headers:
        | string
        | {
            [name: string]: string | string[];
          }
        | any;
      responseType?: any;
    } = { headers: {} },
  ): Observable<any> {
    const qStr = data
      ? '?' +
        _.map(data, (d, k) => {
          return `${k}=${d}`;
        }).join('&')
      : '';
    options.headers = new HttpHeaders(options.headers);
    return this.get(`${url}${qStr}`, {}, options);
  }

  postData(url, body = {}, data?, options?): Observable<any> {
    const qStr = data
      ? '?' +
        _.map(data, (d, k) => {
          return `${k}=${d}`;
        }).join('&')
      : '';
    return this.post(`${url}${qStr}`, body, options);
  }

  getFauxboxCustomer(fauxbox_key: string) {
    return this.get(`/fauxbox/getFauxboxCustomer?fauxbox_key=${fauxbox_key}`);
  }

  getSalesFilterData(account_num: string) {
    return this.get(
      `/dashboards/sales-filters/salesData?account_num=${account_num}`,
    );
  }
  getServiceFilterData(account_num: string) {
    return this.get(
      `/dashboards/service-filters/serviceData?account_num=${account_num}`,
    );
  }
  getOmtHistoryReport(account_num: string): Observable<any> {
    return this.get(
      `/dashboards/omt/history-report/getOmtHistoryReport?account_num=${account_num}`,
    );
  }
  getFullSalesReport(
    paged_params,
    account_num,
    start_date,
    end_date,
    include_wholesale,
  ): Observable<any> {
    return this.get(
      `/dashboards/omt/full-sales-report/getFullSalesReport?account_num=${account_num}&start_date=${start_date}&end_date=${end_date}&include_wholesale=${include_wholesale}&columns=${paged_params.columns}&draw=${paged_params.draw}&length=${paged_params.length}&order=${paged_params.order}&search=${paged_params.search}&start=${paged_params.start}`,
      { headers: { timeout: '60000' } },
    );
  }
  getFullServiceReport(
    paged_params,
    account_num,
    start_date,
    end_date,
    include_internal,
  ): Observable<any> {
    return this.get(
      `/dashboards/omt/full-service-report/getFullServiceReport?account_num=${account_num}&start_date=${start_date}&end_date=${end_date}&include_internal=${include_internal}&columns=${paged_params.columns}&draw=${paged_params.draw}&length=${paged_params.length}&order=${paged_params.order}&search=${paged_params.search}&start=${paged_params.start}`,
      { headers: { timeout: '60000' } },
    );
  }

  downloadExtendedDatesFullServiceReport(
    account_num,
    start_date,
    end_date,
    include_internal,
  ): Observable<any> {
    return this.get(
      `/dashboards/omt/full-service-report/getFullServiceReportExtendedDates?account_num=${account_num}&start_date=${start_date}&end_date=${end_date}&include_internal=${include_internal}`,
      {
        responseType: 'blob',
        headers: { timeout: '180000' },
      },
    );
  }
  downloadExtendedDatesFullSalesReport(
    account_num,
    start_date,
    end_date,
    include_wholesale,
  ): Observable<any> {
    return this.get(
      `/dashboards/omt/full-sales-report/getFullSalesReportExtendedDates?account_num=${account_num}&start_date=${start_date}&end_date=${end_date}&include_wholesale=${include_wholesale}`,
      {
        responseType: 'blob',
        headers: { timeout: '180000' },
      },
    );
  }
  getBrandMarketShare() {
    return this.get(`/elevate/brandMarketShare`);
  }
  getDealerContactCounts(): Promise<any> {
    return this.get(`/cbr/dealerContactCounts`).toPromise();
  }
  getAutoGroupEmailDomains(): Promise<any> {
    return this.get(
      `/auto-groups/autoGroupEmailDomains&?take=20000`,
    ).toPromise();
  }
  getAutoGroupEmailDomains2(): Promise<any> {
    return this.get(
      `/auto-groups/autoGroupEmailDomains2?take=20000`,
    ).toPromise();
  }
  findAutoGroupDealersFromDomainGuess(dnc): Promise<any> {
    return this.get(
      `/auto-groups/findAutoGroupDealersFromDomainGuess?dnc=${dnc}`,
    ).toPromise();
  }
  getAllDealers(gvars?): Observable<any> {
    const params = _.map(
      {
        limit: 10,
        offset: 0,
        cols: 'dealer_uuid,name,state,website,brands,city,zip,geocode',
        ...gvars,
      },
      (d, k) => {
        return `${k}=${d}`;
      },
    ).join('&');
    return this.http.post(
      `${this.baseUrl}/alldealers/allDealers?${params}`,
      gvars,
    );
  }
  async getNewCustomerLookup(gvars?): Promise<any> {
    return await this.get(`/elevate/dealers/getNewCustomerLookup`).toPromise();
  }
  async getEmailBodyFiles(gvars?): Promise<any> {
    return await this.get(`/robomail/getEmailBodyFiles`).toPromise();
  }
  getAllCbrDealers(gvars?): Observable<any> {
    const params = _.map(
      {
        limit: 10,
        offset: 0,
        cols: 'dealer_uuid,name,state,website,brands,city,zip,geocode',
        ...gvars,
      },
      (d, k) => {
        return `${k}=${d}`;
      },
    ).join('&');
    return this.http.post(
      `${this.baseUrl}/alldealers/allCbrDealers?${params}`,
      gvars,
    );
  }
  getAllCbrDealerContacts(gvars?): Observable<any> {
    const params = _.map(
      {
        limit: 100,
        offset: 0,
        ...gvars,
      },
      (d, k) => {
        return `${k}=${d}`;
      },
    ).join('&');
    return this.http.post(
      `${this.baseUrl}/alldealers/allCbrDealerContacts?${params}`,
      gvars,
    );
  }
  sendContactsToHubspot(gvars?): Observable<any> {
    const params = _.map(
      {
        limit: 100,
        offset: 0,
        ...gvars,
      },
      (d, k) => {
        return `${k}=${d}`;
      },
    ).join('&');
    return this.http.post(
      `${this.baseUrl}/alldealers/sendContactsToHubspot?${params}`,
      gvars,
    );
  }
  getCbrDealers(gvars?): Observable<any> {
    const params = _.map(
      {
        limit: 10,
        offset: 0,
        cols: 'dealer_uuid,name,state,website,brands,city,zip,geocode',
        ...gvars,
      },
      (d, k) => {
        return `${k}=${d}`;
      },
    ).join('&');
    return this.get(`/cbr/dealers?${params}`, gvars);
  }
  updateRedirects(dealer_uuids, limit?): Observable<any> {
    limit = _.isUndefined(limit) ? 10 : limit;
    return this.http.post(`${this.baseUrl}/cbr/updateRedirects`, {
      dealer_uuids,
      limit,
    });
  }

  getAllDealersByZip(gvars?): Observable<any> {
    const params = _.map({ ...gvars }, (d, k) => {
      return `${k}=${d}`;
    }).join('&');
    return this.get(`/alldealers/getAllDealersByZip?${params}`);
  }
  getAllDealer(uuid: string) {
    return this.get(`/alldealers?dealer_uuid=${uuid}`).pipe(
      map((rs: any) => {
        return rs[0] ?? {};
      }),
    );
  }
  getGoogleDealerInfo(uuid: string) {
    return this.get(`/alldealers/getGoogleDealerInfo?dealer_uuid=${uuid}`);
  }
  createNewCampaign(uuid: string): Observable<any> {
    return this.post(
      `/elevate/createNewDealerAndCampaign?cbr_uuid=${uuid}`,
      {},
    );
  }
  authLogin(email, password) {
    return this.post(`/auth/login`, { email, password });
  }
  //AutoGroups
  getAutoGroups(take = 10, skip = 0) {
    return this.http.get<AutoGroup[]>(
      `${this.baseUrl}/auto-groups?take=${take}&skip=${skip}`,
    );
  }

  createAutoGroup(autoGroup: AutoGroup) {
    return this.http.post<AutoGroup>(`${this.baseUrl}/auto-groups`, autoGroup);
  }

  updateAutoGroup(autoGroup: AutoGroup) {
    return this.http.put<AutoGroup>(
      `${this.baseUrl}/auto-groups/${autoGroup.uuid}`,
      autoGroup,
    );
  }

  updateDealersAutoGroup(cbr_uuids, auto_group_uuid) {
    return this.put(`/auto-groups/updateDealersAutoGroup`, {
      cbr_uuids,
      auto_group_uuid,
    });
  }

  deleteAutoGroup(uuid: string) {
    return this.delete(`/auto-groups/${uuid}`);
  }
  //Dealers
  getDealers(take = 10, skip = 0) {
    return this.http.get<Dealer[]>(
      `${this.baseUrl}/dealers?take=${take}&skip=${skip}`,
    );
  }
  getDealer(dealer_uuid: string) {
    return this.http.get<Dealer>(
      `${this.baseUrl}/elevate/dealers/${dealer_uuid}`,
    );
  }

  createDealer(dealer: Dealer) {
    return this.http.post<Dealer>(`${this.baseUrl}/elevate/dealers`, dealer);
  }

  updateDealer(dealer: any) {
    return this.http.patch<Dealer>(
      `${this.baseUrl}/elevate/dealers/${dealer.dealer_uuid}`,
      dealer,
    );
  }
  sendRrmReport(account_num) {
    return this.get(`/fauxbox/sendRrmReport?account_num=${account_num}`);
  }
  sendRrmReports() {
    return this.get(`/fauxbox/sendRrmReports`);
  }
  updateSalesServiceHistory(account_num) {
    return this.get(
      `/dashboards/omt/updateSalesServiceHistory?account_num=${account_num}&force_update=true`,
    );
  }
  updateAllSalesServiceHistory() {
    return this.get(`/dashboards/omt/updateAllSalesServiceHistory`);
  }
}
